const generateBackgroundColor = (checked, error)=>{
    if (checked && !error) return 'bg-primary-50';
    return 'bg-w-gray-50';
};
const generateBackgroundPadding = (leadingIconExist)=>{
    if (leadingIconExist) return 'py-1 pl-1 pr-4';
    return 'py-[7px] px-4';
};
const generateLabelStyle = (checked, error)=>{
    if (error) return 'text-w-red-500';
    if (checked) return 'text-primary';
    return 'text-w-gray-900';
};
const generateLeadingIconColor = (checked, error)=>{
    if (checked && !error) return 'text-primary';
    return 'text-w-gray-600';
};
const generateTrailingIconStyle = (checked, error)=>{
    if (checked && !error) return 'text-primary';
    return 'text-w-gray-400';
};

export { generateBackgroundColor, generateBackgroundPadding, generateLabelStyle, generateLeadingIconColor, generateTrailingIconStyle };
